/*
  <shintop-cart-kit-remove> — the one Remove on a kit row in the cart (snippets/shintop-cart-kit.liquid,
  UI Build Queue entry 10, 2026-10-23).

  Without this file the control is Dawn's own remove link for the kit's first pack, so each press
  removes one pack. With it, one press sets every line of the kit to 0 in a single /cart/update.js
  (keyed by line key, so no position can be wrong), bundling the sections window.shintopCart asks
  for, then shintopCart.afterCartWrite — the drawer, the cart page, the bubble and the one publish
  (Settled 2026-10-18: every Shintop cart writer ends there, and nothing else renders the drawer).

  After the re-render the row is gone, so focus would fall to body: it goes to the next row's title,
  or to the empty state's link — the same targets Dawn's own remove uses (cart.js updateQuantity) —
  and the removal is said in the surface's existing status region. Strings come from data-str-*.

  The whole file is one guarded block: on /cart both the drawer and the page load it, and a second
  top-level `class` declaration in a classic script throws (measured 2026-10-23, verify at 375/1440).
*/
if (!customElements.get('shintop-cart-kit-remove')) {
class ShintopCartKitRemove extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    if (this.link) this.link.addEventListener('click', (event) => this.onClick(event));
  }

  async onClick(event) {
    if (!window.shintopCart || !window.routes) return; // no helper: Dawn's link removes one pack
    event.preventDefault();
    if (this.link.getAttribute('aria-disabled') === 'true') return;

    const keys = (this.dataset.keys || '').split(',').filter(Boolean);
    if (!keys.length) return;

    const inDrawer = Boolean(this.closest('cart-drawer'));
    const row = this.closest('tr');
    this.link.setAttribute('aria-disabled', 'true');
    row?.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.remove('hidden'));

    try {
      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: Object.fromEntries(keys.map((key) => [key, 0])),
          sections: window.shintopCart.sections(),
          sections_url: window.location.pathname,
        }),
      });
      const parsed = await response.json();
      if (!response.ok || parsed.status) throw new Error(parsed.description || parsed.message || 'update failed');

      const removed = this.dataset.strRemoved || '';
      await window.shintopCart.afterCartWrite(parsed, { source: 'shintop-cart-kit' });
      ShintopCartKitRemove.refocus(inDrawer);
      ShintopCartKitRemove.announce(inDrawer, removed);
    } catch (error) {
      console.warn('[shintop] could not remove the kit:', error);
      row?.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.add('hidden'));
      this.link.removeAttribute('aria-disabled');
      const errors = document.getElementById(inDrawer ? 'CartDrawer-CartErrors' : 'cart-errors');
      if (errors) errors.textContent = this.dataset.strError || '';
    }
  }

  static refocus(inDrawer) {
    if (inDrawer) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      const target =
        drawer.querySelector('a.cart-item__name') ||
        drawer.querySelector('.drawer__inner-empty a') ||
        drawer.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') trapFocus(drawer, target);
      else target?.focus();
      return;
    }
    const target =
      document.querySelector('#main-cart-items a.cart-item__name') || document.querySelector('.cart__warnings a');
    target?.focus();
  }

  static announce(inDrawer, text) {
    const region = document.getElementById(inDrawer ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text');
    if (!region || !text) return;
    region.textContent = text;
  }
}

customElements.define('shintop-cart-kit-remove', ShintopCartKitRemove);
}
